import React from "react";
import { Dropdown } from "antd";
import { GlobalOutlined, DownOutlined } from "@ant-design/icons";
import { LANGUAGES, useTranslation } from "../i18n/LanguageContext";
import "./LanguageSwitcher.css";

const LanguageSwitcher = ({ className = "" }) => {
    const { lang, setLang } = useTranslation();
    const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

    const items = LANGUAGES.map((l) => ({
        key: l.code,
        label: l.name,
    }));

    return (
        <Dropdown
            menu={{
                items,
                selectable: true,
                selectedKeys: [lang],
                onClick: ({ key }) => setLang(key),
            }}
            trigger={["click"]}
            placement="bottomRight"
        >
            <button
                type="button"
                className={`lang-switcher ${className}`.trim()}
                aria-label="Փոխել լեզուն"
            >
                <GlobalOutlined />
                <span className="lang-switcher__code">{current.label}</span>
                <DownOutlined className="lang-switcher__caret" />
            </button>
        </Dropdown>
    );
};

export default LanguageSwitcher;
